/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Driver_OrdersInputs */

const vi_nav_driver_orders = /** @type {(inputs: Nav_Driver_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn chờ nhận`)
};

/**

* @param {Nav_Driver_OrdersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_driver_orders = /** @type {((inputs?: Nav_Driver_OrdersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Driver_OrdersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_driver_orders(inputs)
});